export default __webpack_public_path__ + "static/media/development_banner.5d708ded.jpg";